import { TestCategory } from "types/tests/core";
import { Band, BandLookup } from "./types";

// TODO(SD-837): the percentile anchors below are placeholder values picked to
// produce reasonable score distributions on typical test data. They are NOT
// derived from a clinical normative sample. Before this report is used in
// production decisions:
//   - source per-metric percentile bands from published norms or our own data
//   - split bands by age (the Band schema already has ageMin/ageMax — currently
//     a single ANY_AGE band is used for every metric)
//   - revisit the bands when test scoring methodology changes
const ANY_AGE = { ageMin: 0, ageMax: 120 } as const;

const wcstBands: Band[] = [
  {
    metric: "accuracy",
    ...ANY_AGE,
    p10: 0.4,
    p25: 0.55,
    p50: 0.7,
    p75: 0.83,
    p90: 0.92,
    direction: "higherIsBetter",
  },
  {
    metric: "averageSelectionTimeSeconds",
    ...ANY_AGE,
    p10: 4,
    p25: 3,
    p50: 2,
    p75: 1.5,
    p90: 1,
    direction: "lowerIsBetter",
  },
];

const readingAssessmentBands: Band[] = [
  {
    metric: "wordsPerMinute",
    ...ANY_AGE,
    p10: 100,
    p25: 150,
    p50: 200,
    p75: 250,
    p90: 300,
    direction: "higherIsBetter",
  },
  {
    metric: "excessiveFixationsPercentage",
    ...ANY_AGE,
    p10: 35,
    p25: 25,
    p50: 15,
    p75: 8,
    p90: 3,
    direction: "lowerIsBetter",
  },
];

const dyscalculiaBands: Band[] = [
  {
    metric: "accuracy",
    ...ANY_AGE,
    p10: 0.5,
    p25: 0.65,
    p50: 0.78,
    p75: 0.88,
    p90: 0.95,
    direction: "higherIsBetter",
  },
  {
    metric: "averageReactionTimeSeconds",
    ...ANY_AGE,
    p10: 4,
    p25: 3,
    p50: 2,
    p75: 1.4,
    p90: 1,
    direction: "lowerIsBetter",
  },
];

const ocularMotilityBands: Band[] = [
  {
    metric: "pursuitGain",
    ...ANY_AGE,
    p10: 0.6,
    p25: 0.75,
    p50: 0.85,
    p75: 0.92,
    p90: 0.97,
    direction: "higherIsBetter",
  },
  {
    metric: "meanError",
    ...ANY_AGE,
    p10: 4,
    p25: 2.5,
    p50: 1.5,
    p75: 0.9,
    p90: 0.5,
    direction: "lowerIsBetter",
  },
];

export const NORMATIVE_BANDS: BandLookup = {
  [TestCategory.WisconsinCardSorting]: wcstBands,
  [TestCategory.ReadingAssessment]: readingAssessmentBands,
  [TestCategory.Dyscalculia]: dyscalculiaBands,
  [TestCategory.OcularMotility]: ocularMotilityBands,
};

export function findBand(category: TestCategory, metric: string, age: number): Band | undefined {
  const bands = NORMATIVE_BANDS[category];
  if (!bands) return undefined;
  return bands.find((b) => b.metric === metric && age >= b.ageMin && age <= b.ageMax);
}
